import { getAssessmentById } from '@/data/assessments'
import { AssessmentDetailPage } from './AssessmentDetailPage'

export function DataAnalyticsAssessment() {
  const assessment = getAssessmentById('data-analytics')!
  return <AssessmentDetailPage assessment={assessment} />
}
